import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { Profile } from '../../../../models/UserStore';
import { AvatarNode } from '../../../Molecules';

import styles from './WebStoreRoleDetailTemplate.module.css';

export type WebStoreRoleDetailTemplateProps = {
  roleName: string;
  profile: Profile | undefined | null;
  expiredAt: Date | undefined;
  userRewardReferralCode: string | undefined;
  onClickRenew: () => void;
  onClickReferRole: () => void;
  onClickReferPartner: () => void;
};

export const WebStoreRoleDetailTemplate = memo(
  ({
    roleName,
    profile,
    expiredAt,
    userRewardReferralCode,
    // onClickRenew,
    onClickReferRole,
    onClickReferPartner,
  }: WebStoreRoleDetailTemplateProps) => {
    const { t, i18n } = useTranslation();
    const options: Intl.DateTimeFormatOptions = {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    };

    const formattedDate = expiredAt
      ? new Intl.DateTimeFormat(i18n.language, options).format(expiredAt)
      : undefined;

    return (
      <div className={styles.roleDetails}>
        <div className={styles.topSection}>
          <div className={styles.titleText}>{t('My Referral Role: ')}</div>
          <div className={styles.userInfoContainer}>
            {profile && (
              <div className={styles.userAvatar}>
                <AvatarNode profile={profile} size={50} />
              </div>
            )}
            <div className={styles.verticalContainer}>
              <div className={styles.userRole}>{t(roleName)}</div>
              {userRewardReferralCode && (
                <div className={styles.distributorId}>
                  {`${t(`ID: `)} ${userRewardReferralCode}`}
                </div>
              )}
            </div>
          </div>
        </div>
        <div className={styles.whiteRow}>
          <div className={styles.date}>
            {t('Expire on: ')} {formattedDate}
          </div>
          {/* <div className={styles.renew} onClick={onClickRenew}>
            {t('Renew')}
          </div> */}
        </div>
        <div className={styles.shareButtonContainer}>
          <div className={styles.shareButton} onClick={onClickReferPartner}>
            {t('Refer Partner')}
          </div>
          <div className={styles.shareButton} onClick={onClickReferRole}>
            {t('Refer Distributor')}
          </div>
        </div>
      </div>
    );
  },
);
